module.exports = __webpack_public_path__ + "static/media/control-box.a94410cc.png";